export interface SystemEvent {
  id: number;
  timestamp: string;
  contextId: string;
  context: string;
  event: string;
  orgId: string;
  userId: string;
  userName: string;
  userEmail: string;
  projectId: string | null;
  jsonData: string | null;
  showUnread: boolean;
}

export interface WireSystemEvent extends Omit<SystemEvent, 'projectId'> {
  workspaceId?: string | null;
  projectId?: string | null;
}

export interface SystemEventQuery {
  from_timestamp?: number;
  to_timestamp?: number;
  contextId?: string;
  context?: string;
  event?: string;
  userId?: string;
  projectId?: string;
  /** @deprecated use `projectId` */
  workspaceId?: string;
  showUnread?: boolean;
  skip?: number;
  take?: number;
}

export interface SystemEventQueryResponse {
  events: SystemEvent[];
  total: number;
  skip: number;
  take: number;
}

export interface SystemEventReadResponse {
  success: true;
}

export function normalizeSystemEvent(wire: WireSystemEvent): SystemEvent {
  return {
    id: wire.id,
    timestamp: wire.timestamp,
    contextId: wire.contextId,
    context: wire.context,
    event: wire.event,
    orgId: wire.orgId,
    userId: wire.userId,
    userName: wire.userName,
    userEmail: wire.userEmail,
    projectId: wire.projectId ?? wire.workspaceId ?? null,
    jsonData: wire.jsonData ?? null,
    showUnread: wire.showUnread,
  };
}

// TODO(backend-cleanup): cloud-agent-backend/internal/domain/types.go SystemEvent
// still emits `workspaceId`. When that becomes `projectId`, this normalizer
// collapses to identity.
